import type { ImgHTMLAttributes } from 'react';

import { LAZY_IMAGE_LOADING } from '@/shared/const/image-props';

/** Совпадает с суффиксом синтетической почты на бэкенде (`telegram-mini-app-session.ts`). */
export const TELEGRAM_PLACEHOLDER_EMAIL_SUFFIX = '@telegram-miniapp.local';

export const isTelegramPlaceholderEmail = (
  email: string | null | undefined,
): boolean =>
  typeof email === 'string' && email.endsWith(TELEGRAM_PLACEHOLDER_EMAIL_SUFFIX);

/**
 * Фото с https://t.me/i/userpic/... (Telegram WebApp) без этого часто не грузится
 * (реферер режет CDN). NextUI Avatar рендерит обычный <img>, не next/image.
 */
export const externalAvatarImgProps: Pick<
  ImgHTMLAttributes<HTMLImageElement>,
  'referrerPolicy' | 'loading' | 'width' | 'height'
> = {
  referrerPolicy: 'no-referrer',
  loading: LAZY_IMAGE_LOADING,
  // Явные размеры <img>: без них аватар в навбаре давал сдвиг макета (CLS).
  // Контейнер NextUI Avatar всё равно ограничивает отображаемый размер.
  width: 40,
  height: 40,
};
